import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import { WorkshopsList } from '../../../data/WorkshopsList';
import './Workshops.css';

export const Workshops = () => {
  return (
    <>
      <TopBar options={PublicOptions} />
      <div className="content">
        <section className="snn-page-section">
          <h1 className="snn-section-title">Workshops</h1>
        </section>
        <div className="snn-page-section">
          {WorkshopsList.map((workshop, index) => {
            return (
              <div key={index} className="snn-panel-form-wrapper workshop-card">
                <div className="workshop-card-img-wrapper">
                  <img src={workshop.img} alt={workshop.name} />
                </div>
                <div className="workshop-card-description-wrapper">
                  <h2 className="snn-user-home-main-content-header">{workshop.name}</h2>
                  <p>{workshop.summary}</p>
                  <p>{workshop.institution}</p>
                    <div>
                        <p className="snn-user-home-main-content-large-semi">Instructors</p>
                        {workshop.instructors.map((instructor, index) => {
                            return <p key={index}>{instructor}</p>;
                        })}

                        <p>
                            <strong>How to register for the Workshop</strong>
                        </p>
                        <p>
                            Please send an email to javierlo21@ens.cnyn.unam.mx with the subject line “Workshop
                            Registration” and provide the following information:
                            <ul>
                                <li>Full name</li>
                                <li>Institution</li>
                            </ul>
                            This email is the sole official channel to finalize your registration.
                        </p>
                    </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
        <Footer/>
    </>
  );
};
